import { Chip, SxProps, Theme } from '@mui/material';
import { useState } from 'react';
import TerminalAgent from './terminalagent';
import TerminalCouponAgent from './terminalcouponagent';
import { useTranslation } from 'react-i18next';

type ViewType = 'syndicates' | 'coupons';

export default function TerminalWrapper({ agentId }: { agentId: number }) {
  const [activeView, setActiveView] = useState<ViewType>('syndicates');
  const { t } = useTranslation();

  const chipStyle: SxProps<Theme> = {
    color: '#FFFFFF',
    fontSize: '16px',
    fontFamily: 'Roboto',
    fontWeight: '700',
    padding: '4px 12px',
    borderRadius: '64px',
    height: '40px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#4075FF'
    }
  };

  return (
    <div style={{ position: 'relative', width: '100%', minHeight: '100vh' }}>
      {/* Active view content */}
      {activeView === 'syndicates' && <TerminalAgent agentId={agentId} />}
      {activeView === 'coupons' && <TerminalCouponAgent agentId={agentId} />}

      {/* Navigation chips in the top right, aligned with the page title. Absolute so they scroll away with the content. */}
      <div style={{
        position: 'absolute',
        top: '48px',
        right: '40px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: '12px',
        zIndex: 1000,
      }}>
        <Chip
          label={t('syndicates')}
          onClick={() => setActiveView('syndicates')}
          sx={{
            backgroundColor: activeView === 'syndicates' ? '#4075FF' : '#112F7C',
            ...chipStyle
          }}
        />
        <Chip
          label={t('unsettled_coupons')}
          onClick={() => setActiveView('coupons')}
          sx={{
            backgroundColor: activeView === 'coupons' ? '#4075FF' : '#112F7C',
            ...chipStyle
          }}
        />
      </div>
    </div>
  );
}
